import React, { useEffect } from "react";
import platformbanner from "../../../main/assets/images/Images/Platform - Images/platformbg.png";
import platform_banner from "../../../main/assets/images/Images/Platform - Images/platform_banner.png";
import Platform from "./Platform";
import { MainPageHeader } from "main/components";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
type Props = {};

const PlatformWrapper = (props: Props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <MainPageHeader
        descriptionClass="text-white-color font-20 mb-20 font-family-roboto"
        HeaderClassName="text-white-color font-40 mb-10 font-family-condensed"
        backgroundImage={platformbanner}
        mobilebgImage={platform_banner}
        heading="Streamline, Operationalize, Optimize and Visualize using Yantr.ai."
        description="Empowering Field Services with AI-Driven Insights"
        buttonGroup={
          <>
          <div className="d-block d-md-none">
            <Link to={"/contact-us"}>
              <Button
                textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                text="Book a Demo" />
            </Link>
          </div>
          <div className="d-none d-md-block">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                  className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo" />
              </Link>
            </div>
            </>
        }
      />
      <div>
        <Platform />
      </div>
    </div>
  );
};

export default PlatformWrapper;
